import React, { Component, Fragment } from "react";
import DeleteModel from "./DeleteModel";
import UpdateModel from "./UpdateModel";
import InviteModel from "./InviteModel";
import BylineModel from "./BylineModel";
import ExternalUpdateModal from "./ExternalUpdateModal";
import AppContext from "../../../contexts/AppContext";

class List extends Component {
    state = {
        delete: false,
        byline: false,
        update: false,
        eupdate: false,
        item: {},
        meta: {},
        invite: false,
        deltype : '',
    };

    /* delete */
    delete = () => {       
        return this.props.delete(this.props.item.id,this.props.item.type);
    };
    deleteTypeParam = (data) => {
        this.setState({ deltype: data })
    }
    toggleDelete = () => {
        this.setState({ delete: this.state.delete === true ? false : true });
    };

    toggleByline = () => {
        this.setState({ byline: this.state.byline === true ? false : true });
    };

    toggleExternalUpdate = () =>
    {
        //this.setState({ eupdate: this.state.eupdate === true ? false : true });

        this.state.eupdate === true
            ? this.setState({ eupdate: false })
            : 
            
            this.props
                  .getItem({
                    id: this.props.item.id,
                    type: 'external',
                })
                  .then(response => {
                      this.setState({ eupdate: true, item: response.data,  meta: response.meta });
                  })
                  .catch(error => {
                      this.context.state.handelError(error);
                  });
    }

    /* update */
    toggleUpdate = () => {
        this.state.update === true
            ? this.setState({ update: false })
            : 
            
            this.props
                  .getItem({
                    id: this.props.item.id,
                    type: 'internal',
                })
                  .then(response => {
                      this.setState({ update: true, item: response.data,  meta: response.meta });
                  })
                  .catch(error => {
                      this.context.state.handelError(error);
                  });
    };

    toggleInvite = () => {        
        this.setState({ invite: this.state.invite === true ? false : true });
    }

    render() {
        return (
            
            <Fragment>
                <tr>
                    <td>{this.props.item.id}</td>
                    <td>
                        {this.props.item.name}
                    </td>
                    <td className="large">{this.props.item.email}</td>
                    <td>
                        <time dateTime={this.props.item.created_at}>
                            {this.props.item.created_at}
                        </time>
                    </td>
                    <td> {this.props.item.email_verified}</td>
                    <td> {this.props.item.type}</td>
                    <td> {this.props.item.state}</td>
                    <td className="text-right large">
                        {this.props.item.type == 'external' ?
                            <button
                                onClick={ this.toggleInvite }
                                type="button"
                                className= 'btn btn-success btn-sm ml-2'
                            >
                                Invite Link
                            </button>
                        : ''}
                        
                        <button
                            onClick={this.props.item.type == 'internal' ? this.toggleUpdate : this.toggleExternalUpdate }
                            type="button"
                            className= 'btn btn-manage btn-sm ml-2'
                        >
                            Manage
                        </button>
                        {/* <button
                            onClick={this.toggleByline}
                            type="button"
                            className="btn btn-primary btn-sm ml-2"
                        >
                            Byline
                        </button> */}
                        <button
                            onClick={this.toggleDelete}
                            type="button"
                            className="btn btn-danger btn-sm ml-2"
                        >
                            Delete
                        </button>
                    </td>
                </tr>
                {this.state.delete === true ? (
                    <DeleteModel
                        delete={this.delete}
                        hideDelete={this.toggleDelete}
                        deleteType={this.deleteTypeParam}
                    ></DeleteModel>
                ) : null}
                {this.state.byline === true ? (
                    <BylineModel                        
                        hideByline={this.toggleByline}  
                        item={this.props.item}                       
                    ></BylineModel>
                ) : null}
                {this.state.update === true ? (
                    <UpdateModel
                        item={this.state.item}
                        meta={this.state.meta}
                        update={this.props.update}
                        hideUpdate={this.toggleUpdate}
                    ></UpdateModel>
                ) : null}
                {this.state.eupdate === true ? (
                    <ExternalUpdateModal 
                        item={this.state.item}
                        meta={this.state.meta}     
                        hideEUpdate={this.toggleExternalUpdate}
                    ></ExternalUpdateModal>
                ) : null}
                
                {this.state.invite === true ? (
                    <InviteModel     
                        link= {this.props.item.link}                   
                        hideInvite={this.toggleInvite}
                    ></InviteModel>
                ) : null}
            </Fragment>
            
        );
    }
}
List.contextType = AppContext;
export default List;



// WEBPACK FOOTER //
// ./src/components/admin/employers/List.js